<template>
	<div class="forum">
		<div v-if="banner && banner.length" class="forum-banner">
			<img
				:src="img.logo"
				v-for="img in banner"
				:key="img.logo"
				alt=""
				@click="openBanner(img.url)"
			/>
		</div>
		<div class="flex forum-body">
			<sub-menu
				@update-hot-label="changeLabels"
				:default-label="search.label.id || ''"
			/>
			<div class="forum-content">
				<forum-search
					@search="searchTopic"
					:label="search.label"
				></forum-search>
				<topic-list
					:page-info="{ pageNum, pages, total }"
					:topic-list="topicList"
					:search="search.search"
					@on-get-more="getMoreList"
					ref="topicList"
				/>
			</div>
			<right-bar>
				<publish-btn-bar></publish-btn-bar>
				<design-tools></design-tools>
				<!-- <latest></latest> -->
			</right-bar>
		</div>
	</div>
</template>

<script>
import SubMenu from "./components/SubMenu";
import ForumSearch from "./components/ForumSearch";
import TopicList from "./components/TopicList";
import RightBar from "./components/RightBar";
// import Latest from './components/Latest';
import DesignTools from "@/components/DesignTools";
import PublishBtnBar from "./components/PublishBtnBar";
import { getHotTopicList } from "@/api/forum";
import { getBannerURL } from "@/api/common";
export default {
	components: {
		SubMenu,
		RightBar,
		// Latest,
		ForumSearch,
		PublishBtnBar,
		TopicList,
		DesignTools,
	},
	name: "ForumIndex",
	data: () => ({
		pageNum: 1,
		pageSize: 20,
		pages: 1,
		search: {
			label: {},
		}, // 搜索条件
		topicList: [], // 主题列表数据
		type: "", // 主题类型
		banner: "", // banner图地址
	}),
	watch: {
		$route() {
			this.type =
				this.$route.params.type === "0" ? "" : +this.$route.params.type;
			this.searchTopic();
		},
	},
	beforeRouteLeave(to, from, next) {
		if (to.name !== "ForumIndex") {
			sessionStorage.removeItem("hot-label");
		}
		next();
	},
	created() {
		this.type = this.$route.params.type === "0" ? "" : +this.$route.params.type;
		this.getBannerURL();
	},
	mounted() {
		const hotLabel = sessionStorage.getItem("hot-label");

		if (hotLabel) {
			this.changeLabels(JSON.parse(hotLabel));
		}
	},
	methods: {
		openBanner() {
			window.open(this.banner.url);
		},
		// 获取banner图地址
		getBannerURL() {
			getBannerURL(3).then(({ data }) => {
				this.banner = (data || []).splice(0, 2);
			});
		},
		//
		changeLabels(label) {
			this.search.label = label;
		},
		// 获取列表数据
		async searchTopic(search) {
			let isOrgSearch = false;
			if (search) {
				isOrgSearch = false;
				this.search = search;
				this.pageNum = 1;
				this.pages = 1;
			} else {
				isOrgSearch = this.pageNum !== 1;
			}
			let params = {
				pageSize: this.pageSize,
				pageNum: this.pageNum,
				search: this.search ? this.search.search : "",
				orderBy: this.search ? this.search.orderBy : "",
				type: this.type,
				label: this.search.label.id,
			};

			try {
				const { code, data, total } = await getHotTopicList(params);

				if (code === 0) {
					console.log(isOrgSearch);
					// if (isOrgSearch) {
					//   this.topicList = [...this.topicList, ...data];
					// } else {
					//   this.topicList = data;
					// }
					this.topicList = data || [];
					this.pages = Math.ceil(total / this.pageSize);
					this.total = total;
				}
			} catch (err) {
				throw err;
			} finally {
				this.$refs.topicList &&
					this.$refs.topicList.requestEnd(this.pages === this.pageNum);
			}
		},
		// 获取更多
		getMoreList(pageNum) {
			this.pageNum = pageNum;
			this.searchTopic();
		},
	},
};
</script>

<style lang="scss" scoped>
.forum {
	&-banner {
		// padding: 20px 0;
		// background-color: #fff;
		text-align: center;
		font-size: 0;
		display: flex;
		padding: 20px 0 0 0;
		width: 1600px;
		overflow: hidden;
		margin: 0 auto;
		> img {
			cursor: pointer;
			flex: 1;
			margin-right: 20px;
			border-radius: 4px;
			height: 120px;
			font-size: 0;
			width: 790px;
			&:nth-last-child(1) {
				margin-right: 0;
			}
		}
	}
}
.forum-body {
	margin: 0 auto;
	width: 75.7%;
	padding-top: 20px;
	.forum-content {
		margin: 0 1.4%;
		width: 58.8%;
	}
}
// 小屏
@include mq($small) {
	.forum {
		width: 100%;
		&-content {
			width: 665px;
		}
	}
}
</style>
